export default __webpack_public_path__ + "static/news-ea236bbb1a53e386cd6274b5e7bda616.jpg";